<template>
<nav class="navbar navbar-expand-lg navbar-light fixed-top">
  <div class="container">
    <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" 
    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation" >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul data-bs-spy="scroll" data-bs-target="#list-example" class="navbar-nav d-flex justify-content-center">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#hero">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#about">About</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#experience">Experience</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#demo">Demo</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#skills">Skills</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'Navbar',
}
$( document ).ready( function($) {
    $( window ).scroll( function () {
      if ( $(document).scrollTop() > 150 ) {
        // Navigation Bar
        $('.navbar').removeClass('animate__animated animate__fadeIn');
        $('.navbar').addClass('animate__animated animate__fadeInDown bg-dark');
      } else {
        $('.navbar').removeClass('animate__animated animate__fadeInDown bg-dark');
        $('.navbar').addClass('animate__animated animate__fadeIn');
      }
    });
    let clicks = 0;
    $('.navbar-toggler').on('click', function() {
      clicks += 1;
      if($(document).scrollTop() < 150 ) {
        if (clicks % 2 !== 0) {
          $('.navbar').addClass('bg-dark')
        } else {
          $('.navbar').removeClass('bg-dark')
        }
      }
    })
  });
</script>

<style lang="scss" scoped>
.navbar {
  .navbar-toggler {
    @media (max-width: 768px) {
      border-color: rgb(255, 250, 250) !important;
    }
  }
    .navbar-nav {
        width: 100%;
        .nav-item {
            font-family: 'Roboto', sans-serif !important;
            font-weight: 500;
            font-size: 1.2rem;
            margin: 0% 2%;
            .nav-link {
                color: white !important;
            }
        }
    }
}
</style>
